import { JobType } from './job-type.model';
import { Employer } from '../employer/employer.model';
import { Employment } from '../employment/employment.model';

export class Job {
  approved: boolean;
  code: string;
  createdBy: string;
  createdOn: string;
  deleteBy: boolean;
  description: string;
  dressCodeFemale: string;
  dressCodeMale: string;
  employerId: string;
  id: string;
  isDelete: boolean;
  jobTypeId: string;
  prerequisites: string;
  requirements: string;
  tasks: string[];
  title: string;
  updatedBy: string;
  updatedOn: string;
  type: string;

  // other
  jobType: JobType;
  employerName: string;
  employer: Employer;
  employment: Employment;
  rateCards?: any;
  variableJobRateCards?: any;
  requestedEntityName?: any;
  requestedDate?: any;
  assignmentStatus?: any;
  rejectedOn?: any;
  city?: any;
  attachments?: any;
  deliverables?: any;
  action?: string;
  quotationRequired?: boolean;
  assignedEntities?: any;
  assignedEntitiesName?: any;
  updateTitleOnly?: boolean;
  viewSeletedWorkOrdersOnly?: boolean;
  actionTitle?: string;
  venueInformation?: any;
  billingType?: string;
  enterpriseName?: any;
  assignmentId?: any;
  createdByEntity?: any;
  selectedClientType?: any;
  enterpriseDetails?: any;
  links?: any[];
  objectives?: any[];
  startDate?: any;
  endDate?: any;
  purchaseOrderRequired?: boolean;
  workOrderApprovalRequired?: boolean;
  manpowerTrackingRequired?: boolean;
  customFieldsArray?: any;
  sop?: any;
  fileAttachments?: any;
  projectCode?: any;
  quotationApprovalRequired?: boolean;
  geoFencingRadius?: any;
  locationTrackingFrequency?: any;
  attendanceLocationTrackerRequired?: boolean;
  attendanceLogOutSelfieRequired?: boolean;
  attendanceLogInSelfieRequired?: boolean;
  signatureRequired?: boolean;
  fromWhere?: any;
  quoteStatusChangeCalled?: boolean
}
